<template>
  <div class="fip-navigation">
    <router-link
      v-if="previousFip"
      v-tealium:click="$stats.fip.onClickNextOrPrevious(item, 'precedent')"
      :to="getLink(previousFip)"
      :aria-label="$t('fip.accessibility.previous', { title: previousFip.title })"
      data-wptv="banniere-precedent"
      class="btn-previous"
      replace>
      <div class="btn-wrapper">
        <span class="icon icon-arrow-previous" aria-hidden="true" />
      </div>
    </router-link>

    <router-link
      v-if="nextFip"
      v-tealium:click="$stats.fip.onClickNextOrPrevious(item, 'suivant')"
      :to="getLink(nextFip)"
      :aria-label="$t('fip.accessibility.next', { title: nextFip.title })"
      data-wptv="banniere-suivant"
      class="btn-next"
      replace>
      <div class="btn-wrapper">
        <span class="icon icon-arrow-next" aria-hidden="true" />
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RouteUtils from '~/route.utils'
import Navik from '@wptv/navik'

export default {
  name: 'FipNavigation',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getPreviousNext: 'fip/getPreviousNext'
    }),
    nextFip () {
      return this.getPreviousNext(this.item.id).next
    },
    previousFip () {
      return this.getPreviousNext(this.item.id).previous
    }
  },
  methods: {
    /**
     * Retrieve link for previous/next navigation
     * @param historyItem
     * @returns {{meta: any, name: string, params: ({episodeTitle: string, id: (*)}|{itemTitle: string, id: (*)})}}
     */
    getLink (historyItem) {
      return {
        name: RouteUtils.getPageRouteName(historyItem.type, historyItem.videoType),
        params: {
          ...RouteUtils.getPageRouteParams(historyItem),
          keepPosition: true,
          navik: {
            navigationMode: Navik.CONSTANT.NAVIGATION_MODE.HORIZONTAL
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .fip-navigation {
    position: relative;
    width: 100%;
    height: 40px;
    z-index: 4;
    pointer-events: none;

    .btn-previous,
    .btn-next {
      position: absolute;
      background: rgba(0, 0, 0, 0.6);
      height: 40px;
      width: 40px;
      @extend %focus-visible;

      .btn-wrapper {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: all;
        font-size: 14px;
        color: $white;
      }

      &:hover {
        &:after {
          opacity: 1;
        }
      }
    }

    .btn-previous {
      @include mediaQueries('left', (xsmall: 15px, medium: 27px, large: 55px));
    }

    .btn-next {
      @include mediaQueries('right', (xsmall: 15px, medium: 27px, large: 55px));
    }
  }
</style>
